/**
 * Single source of truth for the persisted Keycloak access token.
 *
 * Auth and the API layer are coupled through this stored token (see
 * `App.tsx`, which persists it on login/renewal, and `server.ts`, which reads
 * it for every request). Keeping all reads/writes here means the storage
 * mechanism can later change in one place.
 */
export const TOKEN_KEY = "token";

export const getAccessToken = (): string => localStorage.getItem(TOKEN_KEY) ?? "";

export const setAccessToken = (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token);
};

export const clearAccessToken = (): void => {
    localStorage.removeItem(TOKEN_KEY);
};

/**
 * Authorization header for the media-upload requests that post directly to the
 * API (image/audio libraries) instead of going through the generated client.
 */
export const authHeader = (): { authorization: string } => ({
    authorization: `Bearer ${getAccessToken()}`,
});
